import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_LIST_PHIKHAC,
  GET_LIST_PHIKHAC_CHOVAY,
} from "actions/PhiKhac/actionTypes";
import { getListPhiKhacSuccess, getListPhiKhacFailure } from "actions/PhiKhac";
import PhiKhacApi from "service/phiKhacApi";
import { pushNotification } from "utils/notifications";

function* getListPhiKhac(action) {
  try {
    const response = yield call(PhiKhacApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListPhiKhacSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListPhiKhacFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListPhiKhacFailure());
  }
}
function* getListPhiKhacTheoChoVay(action) {
  try {
    const response = yield call(PhiKhacApi.listTheoChoVay, action.dataSearch);
    if (response.ok) {
      yield put(getListPhiKhacSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListPhiKhacFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListPhiKhacFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_PHIKHAC, getListPhiKhac);
  yield takeLatest(GET_LIST_PHIKHAC_CHOVAY, getListPhiKhacTheoChoVay);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
